import common from "./common.json";

export const ms = {
  common,
};
